import {
  MessagesSquare,
  HeartPulse,
  UserRoundSearch,
  CheckCircle2,
} from "lucide-react";

const Option = ({ text }) => {
  const getIcon = () => {
    if (text.includes("گفتگو"))
      return <MessagesSquare className="h-4  text-purple" />;

    if (text.includes("سلامتی") || text.includes("درمانی"))
      return <HeartPulse className="h-4 text-purple" />;

    if (text.includes("پزشک"))
      return <UserRoundSearch className="h-4 text-purple" />;

    return <CheckCircle2 className="h-4  text-purple" />;
  };

  return (
    <div
      className="
      group
      flex items-center
      gap-3
      bg-white/[0.02]
      border border-white/5
      rounded-xl
      px-2 py-2
      transition-all duration-300
      hover:bg-white/[0.05]
      hover:border-white/10
      hover:-translate-y-0.5
      "
    >
      <div className="w-8 h-8 rounded-lg bg-white/5 flex items-center
       justify-center shrink-0 transition-colors duration-300 group-hover:bg-[#8A3FB8]/10">
        {getIcon()}
      </div>

      <span className="text-[11.5px] lg:text-[12.5px] text-white/70
       transition-colors duration-300 group-hover:text-white/90">
        {text}
      </span>
    </div>
  );
};

export default Option;
